import Authenticated from "@/Layouts/Authenticated";
import PageHeading from "@/Components/PageHeading";
import { useForm, usePage } from "@inertiajs/inertia-react";
import LoadingButton from "@/Components/LoadingButton";
import Label from "@/Components/Label";
import TextAreaInput from "@/Components/TextAreaInput";
import MultiSelectInput from "@/Components/MultiSelectInput";

const Quick = () => {
    const breadCrumb = [
        { name: "Dashobard", route: route("dashboard") },
        { name: "Quick SMS", route: null },
    ];

    const { groups } = usePage().props;

    const {
        data,
        setData,
        post,
        errors,
        clearErrors,
        processing,
        transform,
        reset,
    } = useForm({
        phone: "",
        groups: [],
        message: "",
    });

    transform((data) => {
        return {
            ...data,
            groups: _.map(data.groups, "id"),
        };
    });

    function handleSubmit(e) {
        e.preventDefault();
        post(route("sms.alert.quick"), {
            onSuccess: () => reset(),
        });
    }

    function handleCancel(e) {
        e.preventDefault();
    }

    return (
        <div className="py-6">
            <PageHeading heading={"Quick SMS"} breadcrumb={breadCrumb} />
            <div className="mt-8">
                <div className="mx-auto max-w-lg px-4 py-10 pb-12 lg:pb-16">
                    <form onSubmit={handleSubmit}>
                        <div className="space-y-6">
                            <div>
                                <Label name={"phone"} label={"Phone Numbers"} />
                                <TextAreaInput
                                    name={"phone"}
                                    onChange={(e) =>
                                        setData("phone", e.target.value)
                                    }
                                    errors={errors.phone}
                                    value={data.phone}
                                />
                            </div>
                            <div>
                                <MultiSelectInput
                                    items={groups}
                                    selected={data.groups}
                                    setSelected={(e) => setData("groups", e)}
                                    errors={errors.groups}
                                />
                            </div>
                            <div>
                                <Label name={"message"} label={"SMS Message"} />
                                <TextAreaInput
                                    name={"message"}
                                    onChange={(e) =>
                                        setData("message", e.target.value)
                                    }
                                    errors={errors.message}
                                    value={data.message}
                                />
                            </div>
                        </div>
                        <div className="pt-5">
                            <div className="flex justify-end space-x-1">
                                <LoadingButton
                                    type={"button"}
                                    onClick={handleCancel}
                                    loading={processing}
                                    className={"btn-secondary"}
                                >
                                    Cancel
                                </LoadingButton>
                                <LoadingButton
                                    type={"submit"}
                                    loading={processing}
                                    className={"btn-primary"}
                                >
                                    Submit
                                </LoadingButton>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

Quick.layout = (page) => <Authenticated title={"Quick Sms"} children={page} />;

export default Quick;
